/**
 * Adds pointer-hover behaviour to the existing Dawn header menu on desktop.
 * The native <details>/<summary> interaction remains the fallback.
 */
(() => {
  const desktopPointerQuery = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  class VeloraDesktopMenu {
    constructor(menu) {
      this.menu = menu;
      this.details = menu.querySelector(':scope > details');
      this.summary = this.details?.querySelector(':scope > summary');
      this.closeTimer = null;
      this.closeAnimationTimer = null;

      if (!this.details || !this.summary) return;

      this.menu.addEventListener('mouseenter', () => this.open());
      this.menu.addEventListener('mouseleave', () => this.scheduleClose());
      this.menu.addEventListener('focusin', () => this.cancelClose());
      this.menu.addEventListener('focusout', () => this.scheduleClose());
      desktopPointerQuery.addEventListener('change', () => this.syncMode());
      this.syncMode();
    }

    get isDesktopPointer() {
      return desktopPointerQuery.matches;
    }

    get closeDelay() {
      return reducedMotionQuery.matches ? 0 : 150;
    }

    get closeDuration() {
      return reducedMotionQuery.matches ? 0 : 200;
    }

    syncMode() {
      if (this.isDesktopPointer) {
        this.details.classList.add('velora-desktop-menu-hover');
        return;
      }

      this.cancelClose();
      this.details.classList.remove('velora-desktop-menu-hover', 'velora-desktop-menu-closing');
    }

    open() {
      if (!this.isDesktopPointer) return;

      this.cancelClose();
      this.closeOtherMenus();
      this.details.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
    }

    scheduleClose() {
      if (!this.isDesktopPointer || this.menu.contains(document.activeElement)) return;

      this.clearCloseTimer();
      this.closeTimer = window.setTimeout(() => this.close(), this.closeDelay);
    }

    close() {
      if (!this.isDesktopPointer || this.menu.contains(document.activeElement) || !this.details.open) return;

      this.summary.setAttribute('aria-expanded', 'false');
      this.details.classList.add('velora-desktop-menu-closing');

      this.clearCloseAnimationTimer();
      this.closeAnimationTimer = window.setTimeout(() => {
        if (!this.details.classList.contains('velora-desktop-menu-closing')) return;

        this.details.removeAttribute('open');
        this.details.classList.remove('velora-desktop-menu-closing');
      }, this.closeDuration);
    }

    cancelClose() {
      this.clearCloseTimer();
      this.clearCloseAnimationTimer();
      this.details?.classList.remove('velora-desktop-menu-closing');
    }

    closeOtherMenus() {
      const navigation = this.menu.closest('.header__inline-menu');
      if (!navigation) return;

      navigation.querySelectorAll('header-menu > details[open]').forEach((details) => {
        if (details === this.details) return;

        const otherController = details.parentElement?.veloraDesktopMenu;
        if (otherController) otherController.scheduleClose();
      });
    }

    clearCloseTimer() {
      if (this.closeTimer === null) return;
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    clearCloseAnimationTimer() {
      if (this.closeAnimationTimer === null) return;
      window.clearTimeout(this.closeAnimationTimer);
      this.closeAnimationTimer = null;
    }
  }

  document.querySelectorAll('.header__inline-menu header-menu > details').forEach((details) => {
    const menu = details.parentElement;
    if (menu && !menu.veloraDesktopMenu) menu.veloraDesktopMenu = new VeloraDesktopMenu(menu);
  });
})();
